import React from 'react';

import { inject, observer } from 'mobx-react';
import { Card } from '@sogei/react-web-components-catalog';
import {PATH_PORTALE} from '../config/portale-config';


@inject("rootStore")
@observer
class Errore extends React.Component {

  constructor(props) {
    super(props);
  this.errorStore = this.props.rootStore.errorStore
  this.ripristina = this.ripristina.bind(this) 

  }

  componentDidMount() {
    // Sostituisce l'entry corrente nella history
    
  }

   ripristina(actions) {
    
   this.errorStore.ripristina(values,() => {
      
    })
  }
   
  render() {
    const errorStore = this.props.rootStore.errorStore;
    
    const MessaggioErrore = ({ errorStore }) => {
      if (errorStore.error_code){
          if(errorStore.error_code===400){
          return(<>
          <div className="notification shadow alert alert-warning  d-flex" role="alert">
              <div className="alert-content">
          <h3 className="notification-title">Sessione invalida</h3>
                  <p>La sessione di lavoro risulta invalida.</p>
                  <p>Per proseguire nella navigazione è necessario effettuare un ripristino;
                   si verrà reindirizzati all'area autenticata.</p>
              
                  <a  href= {process.env.CONTEXT_PORTALE} className="btn btn-primary" type="button" title="Ripristina">
                    <i className="fas fa-sync"></i>  Ripristina
                  </a>
              </div>
          </div>
              </>)
          
        }
        
        else if(errorStore.error_code===401){
          return(<>
          <div className="notification shadow alert alert-warning  d-flex" role="alert">
              <div className="alert-content">
          <h3 className="notification-title">Utente non abilitato</h3>
                  <p>L'utente non è abilitato all'utilizzo del servizio</p>
                         <a  href= {process.env.CONTEXT_PORTALE} className="btn btn-primary" type="button" title="Ripristina">
                    <i className="fas fa-sync"></i>  Torna all'area riservata
                  </a>
              </div>
          </div>
              </>)
          }
        else if (errorStore.error_code===403){
          return(<>
          <div className="notification shadow alert alert-danger d-flex" role="alert">
              <div className="alert-content">
          <h3 className="notification-title">Mancata autenticazione</h3>
                  <p>Non risulta un autenticazione per l'utente.</p>
                  <p>Per proseguire nella navigazione è necessario effettuare una nuova autenticazione.</p>
              
              </div>
          </div>
              </>)
          }
      }
      else{
          return(<>
          <div className="notification shadow alert alert-danger d-flex" role="alert">
              <div className="alert-content">
          <h3 className="notification-title">Errore</h3>
                  <p>Si è verificato un errore sconosciuto</p>
              
              </div>
          </div>
              </>)
      }    
  }
  return (
      <>
     <br></br>
     <div id="error-msg" className="container-fluid ">
        
        <div className="row justify-content-center align-items-center">
          <div className="col-12 col-lg-6">
          <h2><i className="fas fa-exclamation-triangle fa-2x mb-2 mb-md-0"></i> Attenzione</h2>
          </div>
        </div>
         <MessaggioErrore errorStore={errorStore}></MessaggioErrore> 
       </div>
   
    </>
    
   
    );
  }
}

export default Errore;